export default {"src":"/_next/static/media/retirement.2951b25b.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};